import { For } from 'solid-js';
import { sheet } from '../state/sheet';
import { DropZone } from './DropZone';
import { SlotListItem } from './SlotListItem';

export function SlotList() {
  return (
    <div class="slot-list">
      <div class="slot-list-dropzone">
        <DropZone />
      </div>
      <ul class="slot-list-items">
        <For each={sheet.slots}>
          {slot => (
            <li>
              <SlotListItem slot={slot} />
            </li>
          )}
        </For>
      </ul>
    </div>
  );
}
